// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  InstantSearchApi.beforeCall = function(searchTerm) {    
    /* Change the params before calling api */
    Globals.instantSearchQueryParams.return_all_currency_fields = false;
    Globals.instantSearchQueryParams.currency = Shopify.currency.active;
    Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
    Globals.instantSearchQueryParams.country = Shopify.country;
  }
})();